import { h, Component, Fragment } from "preact";
import { useContext } from "preact/hooks";
import { TranslateContext } from "@denysvuika/preact-translate";
import servicesService from "./services";
import panoramas from "./panoramas";
import brivasteritorijas from '../../../assets/brivasteritorijas'
export default class Map extends Component {
  addLayer(config) {
    const { props, map } = this;
    return map.addLayer({
      ...config,
      layout: {
        ...config.layout,
        visibility: props.selectedLayer == config.id ? "visible" : "none",
      },
    });
  }

  async fetchPoints() {
    const { map } = this;
    const markers = await servicesService.fetchServices();

    map.addSource("points", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: markers,
      },
    });

    map.loadImage("/img/markers/A.png", function (error, image) {
      if (error) throw error;
      map.addImage("custom-marker", image);
    });

    map.loadImage("/img/markers/A.png", function (error, image) {
      if (error) throw error;
      map.addImage("A", image);
    });

    map.loadImage("/img/markers/B.png", function (error, image) {
      if (error) throw error;
      map.addImage("B", image);
    });

    map.loadImage("/img/markers/C.png", function (error, image) {
      if (error) throw error;
      map.addImage("C", image);
    });

    map.loadImage("/img/markers/D.png", function (error, image) {
      if (error) throw error;
      map.addImage("D", image);
    });

    map.loadImage("/img/markers/E.png", function (error, image) {
      if (error) throw error;
      map.addImage("E", image);
    });
    ///
    // map.loadImage("/img/markers/o.png", function (error, image) {
    //   if (error) throw error;
    //   map.addImage("O", image);
    // });
    map.loadImage("/img/markers/z.png", function (error, image) {
      if (error) throw error;
      map.addImage("Z", image);
    });
    map.loadImage("/img/markers/k.png", function (error, image) {
      if (error) throw error;
      map.addImage("K", image);
    });
    map.loadImage("/img/markers/p.png", function (error, image) {
      if (error) throw error;
      map.addImage("P", image);
    });
    map.loadImage("/img/markers/j.png", function (error, image) {
      if (error) throw error;
      map.addImage("J", image);
    });

    map.loadImage("/img/markers/360.png", function (error, image) {
      if (error) throw error;
      map.addImage("360", image);
    });

    var playout = {
      "icon-image": ["get", "label"],
      // "custom-marker",
      "icon-size": 0.5,
      // get the title name from the source's "title" property
      // "text-field": ["get", "title"],
      // "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
      // "text-offset": [0, 1.25],
      // "text-anchor": "top",
    };
    this.addLayer({
      id: "p",
      type: "symbol",
      source: "points",
      layout: playout,
      filter: ["==", "label", "P"],
    });
    this.addLayer({
      id: "k",
      type: "symbol",
      source: "points",
      layout: playout,
      filter: ["==", "label", "K"],
    });
    this.addLayer({
      id: "j",
      type: "symbol",
      source: "points",
      layout: playout,
      filter: ["==", "label", "J"],
    });
    this.addLayer({
      id: "z",
      type: "symbol",
      source: "points",
      layout: playout,
      filter: ["==", "label", "Z"],
    });

    this.addLayer({
      id: "b",
      type: "symbol",
      source: "points",
      layout: playout,
      filter: ["==", "label", "B"],
    });

    // Panoramas
    const pano = panoramas.map((panorama) => ({
      type: "Feature",
      properties: {
        description: panorama.description,
        label: "360",
        panorama,
      },
      geometry: {
        type: "Point",
        coordinates: panorama.coordinates,
      },
    }));
    map.addSource("panorama", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: pano,
      },
    });

    this.addLayer({
      id: "panorama",
      type: "symbol",
      source: "panorama",
      layout: playout,
      filter: ["==", "label", "360"],
    });
    // map.setLayoutProperty("panorama", "visibility", "none");

    function cursorPointer() {
      map.getCanvas().style.cursor = "pointer";
    }
    function cursorDefault() {
      map.getCanvas().style.cursor = "";
    }

    map.on("mouseenter", "k", cursorPointer);
    map.on("mouseleave", "k", cursorDefault);
    map.on("mouseenter", "j", cursorPointer);
    map.on("mouseleave", "j", cursorDefault);
    map.on("mouseenter", "p", cursorPointer);
    map.on("mouseleave", "p", cursorDefault);

    map.on("mouseenter", "z", cursorPointer);
    map.on("mouseleave", "z", cursorDefault);

    map.on("mouseenter", "panorama", cursorPointer);
    map.on("mouseleave", "panorama", cursorDefault);

    map.on("click", "panorama", (e) => {
      const pano = e.features[0];
      if (pannellum) {
        this.setState(
          { panorama: JSON.parse(pano.properties.panorama) },
          () => {
            pannellum.viewer("panorama", this.state.panorama);
          }
        );
        document.body.classList.add("panorama-popup-visible");
      }
    });

    function pointClick(e) {
      var coordinates = e.features[0].geometry.coordinates.slice();
      var description = e.features[0].properties.description;

      // Ensure that if the map is zoomed out such that multiple
      // copies of the feature are visible, the popup appears
      // over the copy being pointed to.
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML('<div style="padding:5px 10px;">' + description + "</div>")
        .addTo(map);
    }

    map.on("click", "k", pointClick);
    map.on("click", "p", pointClick);
    // map.on("click", "o", pointClick);
    map.on("click", "z", pointClick);
    map.on("click", "j", pointClick);

    function pointClickBt(e){
      const coordinates = e.features[0].geometry.coordinates.slice();
      const description = e.features[0].properties.Text;
      let html = '';
      const lang = document.querySelector("html").attributes.lang.value;

      switch (lang) {
        case 'en':
          html='<a target="_blank" href="/en/free-territories-business-operation" class="special-link"><span>Free Territories for Business Operation</span></a>';
          break;
        case 'ru':
          html='<a target="_blank" href="/ru/svobodnye-territorii-dlya-predprinimatelskoy-deyatelnosti" class="special-link"><span>Свободные территории для предпринимательской деятельности</span></a>';
          break;
        case 'lv':
        default:
          html='<a target="_blank" href="/lv/brivas-teritorijas-uznemejdarbibai"><span>Brīvas teritorijas uzņēmējdarbībai</span></a>';
      }
      new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML('<div style="padding:5px 10px;">' + html + "</div>")
        .addTo(map);
    }
    map.on("click", "b", pointClickBt );
    // map.on("click", "brivas", pointClickBt );
  }

  componentDidMount() {
    // const { t, lang } = useContext(TranslateContext);
    const lang = document.querySelector("html").attributes.lang.value;
    this.lang = lang;
    var mapboxgl = window.mapboxgl;
    if (!window.mapboxgl) {
      return setTimeout(() => this.componentDidMount, 500);
    }
    mapboxgl.accessToken =
      "pk.eyJ1IjoiYW5kcmlzbHVzaXMiLCJhIjoiY2tmMjBxbGU2MDhvaDJ5cHd2cDY2YTc2ZCJ9.cyOcTIQZ4iHoIqyB8dNO6w";
    var map = (this.map = new mapboxgl.Map({
      container: "locations-map",
      // style: "mapbox://styles/mapbox/light-v10",
      // style: "mapbox://styles/mapbox/streets-v11",
      style: "/assets/style.json",
      center: [24.0859194, 57.007863],
      zoom: 11,
      trackResize: true,
    }));

    map.addControl(new mapboxgl.NavigationControl());
    map.addControl(new mapboxgl.FullscreenControl());

    map.addControl(
      new mapboxgl.ScaleControl({
        maxWidth: 150,
        unit: "metric",
      })
    );
    // map.addControl(
    //   new mapboxgl.FullscreenControl({ container: document.querySelector("body") })
    // );
    var flown = false;
    map.on("load", () => {
      var query = location.search.substring(1);
      var args = {};
      if (query) {
        query.split("&").map(function (el) {
          var arg = el.split("=");
          if (arg[1]) args[arg[0]] = arg[1];
        });
      }
      if (args.l) {
        var latlon = args.l.split(",");
        map.flyTo({
          center: [latlon[0], latlon[1]],
          zoom: 15,
          essential: true, // this animation is considered essential with respect to prefers-reduced-motion
        });
      }

      this.fetchPoints();

      map.addSource("points3", {
        type: "geojson",
        data: "/geo/3.json",
      });
      // map.addSource("points4", {
      //   type: "geojson",
      //   data: "/geo/4.json",
      // });

      map.addSource("points7", {
        type: "geojson",
        data: "/geo/7.json",
      });

      // this.addLayer({
      //   id: "terminal",
      //   type: "fill",
      //   source: "points3",
      //   paint: {
      //     "fill-color": [
      //       "case",
      //       ["boolean", ["feature-state", "hover"], false],
      //       "#3cb9ff",
      //       "#fff",
      //     ],
      //     "fill-opacity": [
      //       "case",
      //       ["boolean", ["feature-state", "hover"], false],
      //       0.65,
      //       0.65,
      //     ],
      //   },
      //   filter: ["==", "$type", "Polygon"],
      // });

      var paintStyle_brivas = {
        "fill-outline-color": "#303030",
        "fill-color": [
          "case",
          ["boolean", ["feature-state", "hover"], false],
          "#3066BE",
          "#60AFFF",
        ],
        "fill-opacity": [
          "case",
          ["boolean", ["feature-state", "hover"], false],
          0.65,
          0.65,
        ],
      };

      var paintStyle_zalas = {
        "fill-outline-color": "#303030",
        "fill-color": [
          "case",
          ["boolean", ["feature-state", "hover"], false],
          "#309C6D",
          "#57CC99",

        ],
        "fill-opacity": [
          "case",
          ["boolean", ["feature-state", "hover"], false],
          0.65,
          0.65,
        ],
      };

      // map.addLayer({
      //   id: "terminal2",
      //   type: "fill",
      //   source: "points4",
      //   paint: paintStyle,
      //   filter: ["==", "$type", "Polygon"],
      // });
      map.addSource("brivasteritorijas", {
        type: "geojson",
        data: brivasteritorijas
      });
      map.addLayer({
        id: "brivas",
        type: "fill",
        source: 'brivasteritorijas',
        paint: paintStyle_brivas,
        filter: ["==", "$type", "Polygon"],
      });

      map.addSource("points5", {
        type: "geojson",
        data: "/geo/5.json",
      });

      map.addLayer({
        id: "zalaszonas",
        type: "fill",
        source: "points5",
        paint: paintStyle_zalas,
        filter: ["==", "$type", "Polygon"],
      });

      map.addLayer({
        id: "boundary",
        type: "line",
        source: "points3",
        paint: {
          "line-color": "#063b59",
          // 'line-opacity': 0.4
        },
        filter: ["==", "$type", "LineString"],
      });

    //Railway
    map.addSource("port_railway", {
      type: "geojson",
      data: "/assets/dzelzcels.json",
    });
      this.addLayer({
        id: "port_railway",
        type: "line",
        source: "port_railway",
        paint: {
          "line-color": "#d00000",
          "line-width": 2,
        },
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
      });





      //Berths
      map.addSource("berths", {
        type: "geojson",
        data: "/geo/6.json",
      });

      this.addLayer({
        id: "berths",
        type: "line",
        source: "berths",
        paint: {
          "line-color": "#d00000",
          "line-width": 2,
        },
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        filter: ["==", "$type", "LineString"],
      });

      this.addLayer({
        id: "berth_labels",
        type: "symbol",
        source: "berths",
        layout: {
          // 'icon-image': 'P',
          // "icon-size": 0.5,
          "text-field": ["get", "title"],
          "text-font": ["Open Sans Semibold"],
          // 'text-offset': [0, 1.25],
          "text-anchor": "center",
        },
      });

      //end berths

      var hoveredStateId = null;
      var hoveredStateSource = null;

      function hover(e) {
        if (e.features.length > 0) {
          if (hoveredStateId && hoveredStateId) {
            map.setFeatureState(
              { source: hoveredStateSource, id: hoveredStateId },
              { hover: false }
            );
          }
          map.setFeatureState(
            { source: e.features[0].source, id: e.features[0].id },
            { hover: true }
          );

          hoveredStateId = e.features[0].id;
          hoveredStateSource = e.features[0].source;
          // map.setFeatureState(
          // { source: 'points4', id: hoveredStateId },
          // { hover: true }
          // );
        }
        // console.log(hoveredStateSource,hoveredStateId);
      }
      function out(e) {
        if (hoveredStateId && hoveredStateSource) {
          map.setFeatureState(
            { source: hoveredStateSource, id: hoveredStateId },
            { hover: false }
          );
        }
        hoveredStateId = null;
        hoveredStateSource = null;
      }
      map.on("mousemove", "zalaszonas", hover);
      map.on("mouseleave", "zalaszonas", out);

      map.on("mousemove",  "brivas", hover);
      map.on("mouseleave", "brivas", out);


      map.on("mousemove", "terminal2", hover);
      map.on("mouseleave", "terminal2", out);
      // map.on("mousemove", "terminal", hover);
      // map.on("mouseleave", "terminal", out);

      // Insert the layer beneath any symbol layer.
      var layers = map.getStyle().layers;

      var labelLayerId;
      for (var i = 0; i < layers.length; i++) {
        if (layers[i].type === "symbol" && layers[i].layout["text-field"]) {
          labelLayerId = layers[i].id;
          break;
        }
      }

      var layers = map.getStyle().layers.filter(function (layer) {
        return layer.source !== "openmaptiles";
      });

      // // .items-filter li,
      // $(" #locations .filter li").click(function () {
      //   $(this).addClass("active").siblings().removeClass("active");
      //   console.log("layers", layers);
      //   console.log("layer", $(this).data("layer"));
      //   if ($(this).data("layer") == "all") {
      //     for (var i in allLayers) {
      //       map.setLayoutProperty(allLayers[i], "visibility", "visible");
      //     }
      //   } else {
      //     for (var i in allLayers) {
      //       if (i == $(this).data("layer")) continue;
      //       map.setLayoutProperty(allLayers[i], "visibility", "none");
      //     }
      //     map.setLayoutProperty(
      //       $(this).data("layer"),
      //       "visibility",
      //       "visible"
      //     );
      //   }
      // });

      function pointClick2(e) {
        var coordinates = e.features[0].geometry.coordinates.slice()[0][0];
        var description = e.features[0].properties.title;
        // console.log(e.features[0].properties);
        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        new mapboxgl.Popup()
          .setLngLat(coordinates)
          .setHTML('<div style="padding:5px 10px;">' + description + "</div>")
          .addTo(map);
      }

      // map.on("click", "terminal", pointClick2);
      // map.on("click", "terminal2", pointClick2);
      // map.on("click", "zalaszonas", pointClick2);
      /*
      this.addLayer(
        {
          id: "3d-buildings",
          source: "openmaptiles",
          "source-layer": "building",
          filter: ["==", "extrude", "true"],
          type: "fill-extrusion",
          minzoom: 15,
          paint: {
            "fill-extrusion-color": "#aaa",
            // use an 'interpolate' expression to add a smooth transition effect to the
            // buildings as the user zooms in
            "fill-extrusion-height": [
              "interpolate",
              ["linear"],
              ["zoom"],
              15,
              0,
              15.05,
              ["get", "height"],
            ],
            "fill-extrusion-base": [
              "interpolate",
              ["linear"],
              ["zoom"],
              15,
              0,
              15.05,
              ["get", "min_height"],
            ],
            "fill-extrusion-opacity": 0.6,
          },
        },
        labelLayerId
      );
*/
      // // Add an image to use as a custom marker
      // map.loadImage(
      //   "https://docs.mapbox.com/mapbox-gl-js/assets/custom_marker.png",
      //   function (error, image) {
      //     if (error) throw error;

      //     map.addImage("custom-marker", image);
      //     // Add a GeoJSON source with 2 points
      //     map.addSource("points", {
      //       type: "geojson",
      //       data: {
      //         type: "FeatureCollection",
      //         features: [
      //           {
      //             // feature for Mapbox DC
      //             type: "Feature",
      //             geometry: {
      //               type: "Point",
      //               coordinates: [57.007863, 24.0859194],
      //             },
      //             properties: {
      //               title: "Mapbox DC",
      //             },
      //           },
      //           {
      //             // feature for Mapbox SF
      //             type: "Feature",
      //             geometry: {
      //               type: "Point",
      //               coordinates: [-122.414, 37.776],
      //             },
      //             properties: {
      //               title: "Mapbox SF",
      //             },
      //           },
      //         ],
      //       },
      //     });

      //     // Add a symbol layer
      //     this.addLayer({
      //       id: "points",
      //       type: "symbol",
      //       source: "points",
      //       layout: {
      //         "icon-image": "custom-marker",
      //         // get the title name from the source's "title" property
      //         "text-field": ["get", "title"],
      //         "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
      //         "text-offset": [0, 1.25],
      //         "text-anchor": "top",
      //       },
      //     });
      //   }
      // );
      map.resize();
      this.componentWillReceiveProps(this.props);

    });
  }
  componentWillReceiveProps(newProps) {
    if (newProps.selectedLayer) {
      this.showLayer(newProps.selectedLayer);
    }
  }
  showLayer(layer) {
    const { map } = this;
    var mapLayers = map.getStyle().layers.filter(layer=>layer.source!=='openmaptiles').reduce((acc,el)=>({...acc,[el.id]:el}),{});
    if (this.props.layers) {
      this.props.layers.map((group) =>
        group.children.map((l) => {
          try {
            if (l.key != layer) {
              if (l.related && l.related.length) {
                l.related.map((rel) =>{
                  if (mapLayers[rel]) map.setLayoutProperty(rel, "visibility", "none");
                }
                );
              }
              if (l.key.substr(0, 4) == "all-") {
                //
              } else {
                if (mapLayers[l.key]) map.setLayoutProperty(l.key, "visibility", "none");
              }
            } else {
              if (mapLayers[layer]) map.setLayoutProperty(layer, "visibility", "visible");
              if (l.related && l.related.length) {
                l.related.map((rel) =>{
                  if (mapLayers[rel]) map.setLayoutProperty(rel, "visibility", "visible");
                }
                );
              }
            }
          } catch (e) {}
        })
      );
    }

    if (layer.substr(0, 4) == "all-") {
      const group = this.props.layers.filter(
        (group) => group.key == layer.substr(4)
      );
      if (group) {
        group[0].children.map((l) => {
          try {
            if (l.key != layer) {
              map.setLayoutProperty(l.key, "visibility", "visible");
              if (l.related && l.related.length) {
                l.related.map((rel) =>{
                  if (mapLayers[rel]) map.setLayoutProperty(rel, "visibility", "visible")
                }
                );
              }
            } else {
              if (mapLayers[layer]) map.setLayoutProperty(layer, "visibility", "visible");
              if (l.related && l.related.length) {
                l.related.map((rel) =>{
                  if (mapLayers[rel]) map.setLayoutProperty(rel, "visibility", "visible")
                }
                );
              }
            }
          } catch (e) {}
        });
      }
    } else {
    }

    // // const allLayers = ["k", "o", "p","z"];
    // if (layer == "all") {
    //   for (var i in allLayers) {
    //     map.setLayoutProperty(allLayers[i], "visibility", "visible");
    //   }
    // } else {
    //   for (var i in allLayers) {
    //     if (i == layer) continue;
    //     map.setLayoutProperty(allLayers[i], "visibility", "none");
    //   }
    //   map.setLayoutProperty(layer, "visibility", "visible");
    // }
  }

  render() {
    const { panorama } = this.state;
    return (
      <Fragment>
        <div id="locations-map"></div>
        {!!panorama && (
          <div
            class={"panorama-popup " + (panorama ? "visible" : "")}
            id="panoramaPopup"
            // onclick="void(0);"
          >
            <div id="panorama" class="pnlm-container" tabindex="0">
              <div class="pnlm-ui pnlm-grab">
                <div class="pnlm-dragfix"></div>
                <span class="pnlm-about-msg" style="display:none !important;">
                  {/* <a href="https://pannellum.org/" target="_blank">
                    Pannellum
                  </a>{" "}
                  2.5.5 */}
                </span>
                <div
                  class="pnlm-sprite pnlm-hot-spot-debug-indicator"
                  style="display: none;"
                ></div>
                <div class="pnlm-panorama-info" style="display: none;">
                  <div class="pnlm-title-box"></div>
                  <div class="pnlm-author-box"></div>
                </div>
                <div class="pnlm-load-box" style="display: none;">
                  <p>Ielādē...</p>
                  <div class="pnlm-lbox">
                    <div class="pnlm-loading"></div>
                  </div>
                  <div class="pnlm-lbar">
                    <div class="pnlm-lbar-fill" style="width: 100%;"></div>
                  </div>
                  <p class="pnlm-lmsg"></p>
                </div>
                <div class="pnlm-error-msg pnlm-info-box"></div>
                <div class="pnlm-controls-container">
                  <div
                    class="pnlm-zoom-controls pnlm-controls"
                    style="display: none;"
                  >
                    <div class="pnlm-zoom-in pnlm-sprite pnlm-control"></div>
                    <div class="pnlm-zoom-out pnlm-sprite pnlm-control"></div>
                  </div>
                  <div
                    class="pnlm-fullscreen-toggle-button pnlm-sprite pnlm-fullscreen-toggle-button-inactive pnlm-controls pnlm-control"
                    style="display: none;"
                  ></div>
                </div>
                <div class="pnlm-load-button" style="display: none;">
                  <p>Ielādēt</p>
                </div>
                <div
                  class="pnlm-compass pnlm-controls pnlm-control"
                  style="display: none;"
                ></div>
              </div>
              <div class="pnlm-render-container">
                <canvas
                  width="1363"
                  height="1948"
                  style="height: 100%; width: 100%;"
                ></canvas>
              </div>
            </div>
            <button
              class="close-button"
              id="closeButton"
              onClick={() => {
                this.setState({ panorama: null });
                document.body.classList.remove("panorama-popup-visible");
              }}
            >
              <svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="512px"
                height="320px"
                viewBox="0 96 512 320"
                enable-background="new 0 96 512 320"
                xmlSpace="preserve"
              >
                <path
                  fill="#073c5c"
                  d="M384,416c70.577,0,128-57.422,128-128s-57.423-128-128.001-128H96V96L0,192l96,96.001v-64h287.999
           c35.297,0,64,28.703,64,64S419.296,352,383.999,352h-379v64H384L384,416z"
                ></path>
              </svg>
            </button>
            <div class="user-content visible" id="infoContainer">
              <h2 id="infoTitle">{panorama.title}</h2>
              <p id="infoDescription">{panorama.description}</p>
              <button
                id="mobileToggleDescription"
                class="description open"
              ></button>
              {/* <!-- <button id="closeInfo"></button> --> */}
            </div>
            <div class="logos visible" id="panoramaLogos">
              <div class={"logo-images "+this.lang}></div>
            </div>
            {/* <button class="prev panorama-button" id="panoramaPrev">
              <span class="icon"></span>
            </button>
            <button class="next panorama-button" id="panoramaNext">
              <span class="icon"></span>
            </button> */}
          </div>
        )}
      </Fragment>
    );
  }
}
